import { Link } from 'react-router-dom';

export interface RelatedPageItem {
  title: string;
  desc: string;
  href: string;
  external?: boolean;
}

interface RelatedPagesProps {
  items: RelatedPageItem[];
}

export default function RelatedPages({ items }: RelatedPagesProps) {
  return (
    <section className="py-14 bg-[#f7faf7] border-t border-gray-100">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <h2 className="text-[#1a2e1a] font-bold text-[1.25rem] mb-8">您可能也想了解</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <div
              key={item.href}
              className="bg-white rounded-xl p-6 border border-gray-100 hover:border-green-200 hover:-translate-y-0.5 transition-all duration-200 flex flex-col"
            >
              <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-2 leading-snug">{item.title}</h3>
              <p className="text-gray-500 text-[0.875rem] leading-[1.75] flex-1 mb-5">{item.desc}</p>
              {item.external ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-1.5 text-[#4CAF50] font-semibold text-[0.875rem] hover:gap-2.5 transition-all duration-200 cursor-pointer"
                >
                  前往了解
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-external-link-line text-sm" />
                  </div>
                </a>
              ) : (
                <Link
                  to={item.href}
                  className="whitespace-nowrap inline-flex items-center gap-1.5 text-[#4CAF50] font-semibold text-[0.875rem] hover:gap-2.5 transition-all duration-200 cursor-pointer"
                >
                  前往了解
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </div>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
